/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InterventionResource } from '../models/InterventionResource';
import type { RdvCompteRenduMetreRequest } from '../models/RdvCompteRenduMetreRequest';
import type { RdvRequest } from '../models/RdvRequest';
import type { RdvResource } from '../models/RdvResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RdvService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Debriefer un rendez-vous
     * Enregistre l'issue du rendez-vous (`debrief_categorie_selected`, `debrief_type_selected`). Pour les categories « devis a faire » et « devis fait », un devis est cree sur le projet avec `devis.price_ht`, `devis.price_ttc`, `devis.tva`, et le projet avance d'etape. Un rendez-vous deja debriefe est refuse. En cas d'echec, rien n'est enregistre (422 avec le detail).
     * @param idRdv
     * @param requestBody
     * @returns RdvResource `RdvResource`
     * @throws ApiError
     */
    public rdvDebriefRdv(
        idRdv: string,
        requestBody: {
            debrief_categorie_selected: number;
            debrief_type_selected: number;
            devis?: {
                price_ttc?: string;
                price_ht?: string;
                tva?: string;
            };
        },
    ): CancelablePromise<RdvResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/rdvs/debrief/{id_rdv}',
            path: {
                'id_rdv': idRdv,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Compte-rendu de metre
     * Reserve aux metreurs, sur un rendez-vous de nature « Metre » dont le projet est au stade de la commande. Confirme les cotes du devis signe `IDDEVIS` et cree l'intervention de pose (`LIBELLE`, `IDTYPE_INTERVENTION`, `DATE_DE_POSE`, `SEMAINE_DE_POSE`, `NBPERSONNES`, duree en `NOMBRE_HEURE` / `NOMBRE_MINUTE`...). 422 si le rendez-vous, le projet ou le devis ne remplissent pas les conditions ; 403 si vous n'etes pas metreur. En cas d'echec, rien n'est enregistre.
     * @param idRdv
     * @param requestBody
     * @returns InterventionResource `InterventionResource`
     * @throws ApiError
     */
    public rdvCompteRenduMetre(
        idRdv: string,
        requestBody: RdvCompteRenduMetreRequest,
    ): CancelablePromise<InterventionResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/rdvs/{id_rdv}/compte-rendu-metre',
            path: {
                'id_rdv': idRdv,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `An error`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Deplacer un rendez-vous
     * Change uniquement `RDV_DEBUT` et `RDV_FIN`, sans toucher aux affectations ni aux autres champs.
     * @param idRdv
     * @param requestBody
     * @returns RdvResource `RdvResource`
     * @throws ApiError
     */
    public rdvReschedule(
        idRdv: string,
        requestBody: {
            RDV_DEBUT: string;
            RDV_FIN: string;
        },
    ): CancelablePromise<RdvResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/rdvs/{idRDV}/reschedule',
            path: {
                'idRDV': idRdv,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Rendez-vous d'une periode
     * Les rendez-vous du personnel connecte entre `RDV_DEBUT` et `RDV_FIN`. Un directeur commercial peut consulter l'agenda d'un autre personnel avec `user_id_impersonate`.
     * @param rdvDebut
     * @param rdvFin
     * @param rdvObjet
     * @param idadresse
     * @param observations
     * @param idnatureRdv
     * @param idprojet
     * @param idsPersonnel
     * @returns RdvResource Array of `RdvResource`
     * @throws ApiError
     */
    public rdvsIndex(
        rdvDebut: string,
        rdvFin: string,
        rdvObjet?: string | null,
        idadresse?: number | null,
        observations?: string | null,
        idnatureRdv?: number,
        idprojet?: number | null,
        idsPersonnel?: Array<number>,
    ): CancelablePromise<Array<RdvResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/rdvs',
            query: {
                'RDV_DEBUT': rdvDebut,
                'RDV_FIN': rdvFin,
                'RDV_OBJET': rdvObjet,
                'IDADRESSE': idadresse,
                'OBSERVATIONS': observations,
                'IDNATURE_RDV': idnatureRdv,
                'IDPROJET': idprojet,
                'idsPersonnel': idsPersonnel,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Creer un rendez-vous
     * Sur le projet `IDPROJET`, avec les personnels `idsPersonnel` — le createur est toujours ajoute. L'historique du rendez-vous est mis a jour. 201 avec le rendez-vous cree.
     * @param requestBody
     * @returns RdvResource `RdvResource`
     * @throws ApiError
     */
    public rdvsStore(
        requestBody: RdvRequest,
    ): CancelablePromise<RdvResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/rdvs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un rendez-vous
     * Avec l'adresse, le projet (client, adresse de chantier, devis) et les personnels affectes.
     * @param id
     * @returns RdvResource `RdvResource`
     * @throws ApiError
     */
    public rdvsShow(
        id: string,
    ): CancelablePromise<RdvResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/rdvs/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
    /**
     * Modifier un rendez-vous
     * Si `idsPersonnel` est envoye, il **remplace** les affectations (le personnel connecte est toujours conserve). 404 si le rendez-vous n'existe pas.
     * @param idRdv
     * @param requestBody
     * @returns RdvResource `RdvResource`
     * @throws ApiError
     */
    public rdvsUpdate(
        idRdv: string,
        requestBody: RdvRequest,
    ): CancelablePromise<RdvResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/rdvs/{idRDV}',
            path: {
                'idRDV': idRdv,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Annuler un rendez-vous
     * Le rendez-vous est marque annule : il disparait des listes mais reste consultable par identifiant. Renvoie le rendez-vous annule. Un identifiant inconnu renvoie 200 avec le message `rdv introuvable`.
     * @param idRdv
     * @returns any `RdvResource`
     * @throws ApiError
     */
    public rdvsDestroy(
        idRdv: string,
    ): CancelablePromise<(RdvResource | string)> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/rdvs/{idRDV}',
            path: {
                'idRDV': idRdv,
            },
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
